import { switchLanguage } from './langUtils';

export default class Lang {
  langOtherBtn: HTMLButtonElement;

  langOtherContainer: HTMLElement;

  supportedLangs = ['ru', 'sr', 'en'];

  defaultLang = 'en';

  constructor() {
    this.langOtherBtn = document.querySelector('.header__lang-arrow') as HTMLButtonElement;
    this.langOtherContainer = this.langOtherBtn.nextElementSibling as HTMLElement;
    this.init();
  }

  init = () => {
    // Открытие выпадающего списка языков
    this.langOtherBtn.addEventListener('click', () => {
      this.langOtherContainer.classList.toggle('active');
    });

    // Обработка клика по кнопкам языка
    document.querySelectorAll('[data-lang]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const lang = btn.getAttribute('data-lang');
        if (lang) {
          switchLanguage(lang.toLowerCase());
        }
      });
    });
  };
}
